import { Unit } from '../../../../shared/common/units';
import { RemoteServiceUnitType, UnitsAdaptee } from '../units.model';

export class RemoteServiceUnitsAdaptee implements UnitsAdaptee {
  constructor() {}

  standardizeUnit(unit: Unit | string): string {
    switch (unit) {
      case RemoteServiceUnitType.Percentage:
        return Unit.Percent;
      case RemoteServiceUnitType.Celsius:
      case RemoteServiceUnitType.Celcius:
        return Unit.Celsius;
      case RemoteServiceUnitType.DecibelMilliwat:
        return Unit.Dbm;
      case RemoteServiceUnitType.Hour:
        return Unit.Hour;
      case RemoteServiceUnitType.Kelvin:
        return Unit.Kelvin;
      case RemoteServiceUnitType.PercentageMinutePerKelvin:
        return Unit.KelvinPerMinute;
      case RemoteServiceUnitType.KiloWattHours:
        return Unit.KilowattHour;
      case RemoteServiceUnitType.LiterPerHour:
        return Unit.LiterHour;
      case RemoteServiceUnitType.Minute:
        return Unit.Minute;
      case RemoteServiceUnitType.Bar:
        return Unit.Bar;
      case RemoteServiceUnitType.Watt:
        return Unit.Watt;
      case RemoteServiceUnitType.Percentage:
      case RemoteServiceUnitType.Percent:
        return Unit.Percent;
      case RemoteServiceUnitType.Number:
      case RemoteServiceUnitType.StartsPerHour:
      case RemoteServiceUnitType.Ratio:
      case RemoteServiceUnitType.Boolean:
      case RemoteServiceUnitType.NoUnit:
        return Unit.NoUnit;
      default:
        return unit;
    }
  }
}
